<template>
  <div class="bofangChater">
    <div class="box-item"><i class="listIcon"></i>课程列表</div>
    <el-collapse @change="onChnage" accordion v-model="openIndex">
      <el-collapse-item :name="grounpIndex" v-for="(grounp, grounpIndex) in CourseList" :key="grounpIndex">
        <template slot="title">
          <div v-if="grounpIndex == $route.query.openIndex && !changeItem" class="isBofangs"></div>
          <span class="ellipsis"> {{ grounp.videoChapterName }}</span>
          <span class="audition" v-if="grounp.audition && !IsPurchase">可试听</span>
        </template>
        <div class="chat-item" v-for="(item, index) in grounp.queryVideoNodeList" :key="index">
          <div class="item-title" :class="playid == item.nodeId ? 'active' : ''"
            @click.stop="check(item, 1, grounp)">
            <div v-if="playid == item.nodeId" class="isbofang"></div>
            <div class="title w-b-100 ellipsis" :class="{ ispadding: playid != item.nodeId }">
              {{ item.nodeName }}
            </div>
          </div>
          <div class="but-list" v-if="$route.query.classProductLine !== '1'">
             <div v-if="item.whetherAttachment" class="keep-learn" @click.stop="ktData(item, 1)">
                随堂讲义
              </div>
              <div v-if="item.whetherPaper" class="keep-learn" @click.stop="cgeckTask(item)">
                随堂测试
              </div>
              <div v-if="item.whetherMeans" class="keep-learn" @click.stop="ktData(item, 2)">
                随堂资料
              </div>
          
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="warpCpons" @touchmove.stop.prevent="stop()" v-if="dialogVisible">
      <div>
        <img class="imga" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/No1.png" />
        <img class="imgb" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/close.png"
          @click="tChuang" />
        <span>您暂未购买该课程哦~</span>
      </div>
    </div>
    <!-- 是否可以观看弹窗 -->
    <div class="lookBg" v-if="showLookDetail">
      <div class="ifLook">
        <div class="prompt">提示</div>
        <div class="contents">
          您当前正在<span>{{ lookDeatil ? lookDeatil.terminal : "" }}</span>观看<span>{{ lookDeatil ? lookDeatil.chapterName :
            ""
            }}</span>,请关闭后再行观看其他章节。
        </div>
        <div class="button" @click="closeLook">关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import { getClassCourseById } from '@/api/home'
import { IsLive } from "@/api/emun";
import { getInfo, getToken } from "@/api/cookies";
// import { AnswerClient } from '@/api/task/answerClient'
// let answerClient = new AnswerClient()
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  data() {
    return {
      userInfo: null,
      IsLive: IsLive,
      CourseList: [],
      dialogVisible: false,
      openIndex: this.$route.query.openIndex ? +this.$route.query.openIndex : 0,
      index: 0,
      checkItem: {},
      changeItem: true,
      lookDeatil: null,
      showLookDetail: false,
    };
  },
  props: ["id", "playid", "classId"],
  async created() {
    this.userInfo = getInfo();
    await homeClient
      .queryCourseJxyDetails({
        courseId: this.id,
      })
      .then((res) => {
        this.CourseList = res.data.videoList;
      });
  },
  mounted() {
    let bofangChater = document.querySelector(".bofangChater");
    if (this.dot) {
      bofangChater.style.height = "720px";
    } else {
      bofangChater.style.height = "556px";
    }
  },
  methods: {
    onChnage(name) {
      this.changeItem = name;
    },
    tChuang() {
      this.dialogVisible = false;
    },
    stop() {
      return;
    },
    //观看回放
    check(item, groupId, group) {
      // 可试听
   

      this.checkItem = item;

      let userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
        const sub = {
        id: item.nodeId,
        courseId: this.id,

      };
      for (const key in sub) {
        if (!sub[key] && sub[key] !== 0) {
          delete sub[key];
        }
      }
      const data = Vue.prototype.export(sub);
      // 先刷新页面再跳转到目标路由
      const fullPath = window.location.origin + this.$router.resolve(`/dianbofang?${data}`).href;
      window.location.href = fullPath; 
    
    },
    // 课堂作业
    cgeckTask(item) {
           Vue.prototype.goExam({ contactId: item.paperId, examType: 6 });

    },
    closeLook() {
      this.showLookDetail = false;
    },
    //随堂资料
    ktData(item, type) {
      let userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
        try {
        const params = new URLSearchParams({
          type: type,
          ChatId: item.nodeId,
          courseId: this.id,
        });
        window.open(`/data/dataPackageDetail?${params.toString()}`, "_blank");
      } catch (error) {
        console.error("打开资料详情失败:", error);
      }
      
    },
  },
};
</script>
<style lang="less" scoped>
.bofangChater {
  background: #383838;
  border-radius: 8px 8px 8px 8px;
  // height: 100%;
  height: 556px;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  width: 100%;

  .isBofangs {
    width: 14px;
    height: 14px;
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/bofang.png") no-repeat top left / 100% 100%;
    margin-right: 10px;
  }

  .isbofang {
    display: inline-block;
    width: 16px;
    height: 14px;
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/bofang.png") no-repeat top left / 100% 100%;
    margin-right: 14px;
  }

  .box-item {
    padding: 0px 20px;
    align-items: center;
    display: flex;
    height: 48px;
    line-height: 48px;
    background: #444444;
    border-radius: 8px 8px 0px 0px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;

    .listIcon {
      width: 16px;
      height: 16px;
      background: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/kecheng/listIcon.png") no-repeat top left / 100% 100%;
      margin-right: 6px;
    }

    .iconfont {
      font-size: 16px;
      margin-right: 3px;
    }

    margin-bottom: 4px;
  }
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}

/deep/ .el-collapse {
  border: none !important;

  .el-collapse-item__header {
    padding: 0px 20px;
    min-height: 48px;
    height: auto;
    background: #555555;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    line-height: 48px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
    border: none;
    margin-top: 4px;
  }

  .el-collapse-item__content {
    padding: 0px;
  }

  .el-collapse-item__wrap {
    border: none;
  }
}

/* 试听 */
.audition {
  width: 48px;
  height: 20px;
  background: #ffedeb;
  border-radius: 2px 2px 2px 2px;
  font-size: 12px;
  font-family: Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ff5e51;
  line-height: 20px;
  margin-left: 8px;
  text-align: center;
  flex-shrink: 0;
}

/* 节 */
.chat-item {
  width: 100%;
  border-bottom: 1px solid #555555;
  padding: 16px 20px;
  background: #383838;

  .active {
    color: #ff5e51;

    .iconfont,
    .title {
      color: #ff5e51 !important;
    }
  }

  .item-title {
    display: flex;
    width: 100%;
    align-items: center;
    cursor: pointer;

    .iconfont {
      font-size: 14px;
      margin-right: 12px;
      color: #ffffff;
      flex-shrink: 0;
    }

    .ispadding {
      margin-left: 32px;
    }

    .title {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;
    }
  }

  .but-list {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    margin-right: 16px;

    .keep-learn {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 22px;
      margin-left: 12px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #d2d2d2;
      font-size: 10px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      padding: 0 !important;
    }
  }
}

::v-deep .el-collapse-item__arrow {
  transform: rotate(90deg) !important;
}

::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg) !important;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
